/* eslint-disable react/no-array-index-key */
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useMutation, useQueryClient } from 'react-query';
import { Box, Flex } from 'rebass/styled-components';
import styled from 'styled-components';

import Button from '@/components/Button/Button';
import Divider from '@/components/Divider';
import { CheckMarkIcon } from '@/components/Icon';
import Modal from '@/components/Modal';
import Text from '@/components/Text';
import { toast } from '@/components/Toaster/Toaster';
import { userApi } from '@/services';
// import { ContinuousColorLegend } from 'react-vis';

const TextBox = styled(Box)``;
TextBox.defaultProps = {
  px: ['10px', '30px', '40px'],
};

const ChecklistItem = ({ children, ...props }) => (
  <Flex {...props} mb="0">
    <Box mt="5" mr="20px">
      <CheckMarkIcon />
    </Box>
    <Text fontSize={['12px', '12px', '12px']} lineHeight={['24px', '24px', '26px']} textAlign="left">
      {children}
    </Text>
  </Flex>
);
ChecklistItem.propTypes = {
  children: PropTypes.node.isRequired,
};
ChecklistItem.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  mb: '6',
};

const dialogStyle = {
  'min-width': '320px',
  'max-width': '700px',
};

const DialogButton = styled(Flex)``;
DialogButton.defaultProps = {
  px: '10px',
  width: ['100%', '100%', '50%'],
  my: ['16px', '16px', '0'],
};

const fetchDeleteProject = async (id) => {
  await userApi.delete(`/projects/${id}`);
};

const ProjectDeleteDialog = ({ currentProjectId, onCloseClick, dashboard }) => {
  const queryClient = useQueryClient();
  const router = useRouter();
  const { mutateAsync: deleteProject } = useMutation(fetchDeleteProject, {
    onSuccess: () => {
      queryClient.invalidateQueries('project');
      queryClient.removeQueries(['project', currentProjectId]);
      router.push(dashboard ? `/dashboard?area=projects` : `/projekte`);
      toast({
        type: 'success',
        message: 'Projekt erfolgreich gelöscht',
        dismissable: true,
        withIcon: true,
      });
    },
  });

  const handleDeleteClick = () => {
    deleteProject(currentProjectId);
    onCloseClick();
  };

  return (
    <Modal style={dialogStyle} showDialog={currentProjectId} onCloseClick={onCloseClick} ariaLabel="content.title">
      <Box>
        <Text as="h2" textAlign="center" mt="0" mb={['20px', '20px', '20px']} variant="headline" color="primary">
          Projekt löschen
        </Text>
        <Box my="32px">
          <Text pb={['2rem']} textAlign="center" variant="bodyBold">
            Sind Sie sicher, dass Sie das Projekt unwiderruflich löschen möchten?
          </Text>
          <Text textAlign="center" variant="body">
            Mit dem Löschen des Projekts werden alle Aufgaben und Unteraufgaben gelöscht. Ihre angefügten Dokumente
            bleiben im Dokumentencenter bestehen.
          </Text>
        </Box>
        <Divider mb="32px" />
        <Flex flexWrap="wrap" justifyContent="space-between" flexDirection={['column', 'column', 'row']}>
          <DialogButton>
            <Button onClick={handleDeleteClick} variant="secondary" width={['100%', '100%', 'auto']}>
              Projekt löschen
            </Button>
          </DialogButton>
          <DialogButton justifyContent={['flex-start', 'flex-start', 'flex-end']}>
            <Button onClick={onCloseClick} variant="primary" width={['100%', '100%', 'auto']}>
              Abbrechen
            </Button>
          </DialogButton>
        </Flex>
      </Box>
    </Modal>
  );
};

ProjectDeleteDialog.propTypes = {
  currentProjectId: PropTypes.string.isRequired,
  dashboard: PropTypes.string.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};

export default ProjectDeleteDialog;
